import { GOOGLE_CLICK_ID_DATE_REGEX } from '../constants';

export const getGoogleClickIdDateFromCookie = (): string | undefined => {
  const result = document.cookie.match(GOOGLE_CLICK_ID_DATE_REGEX);

  if (result) {
    return result[1];
  }
};
